import { styled } from 'linaria/react';
import { css } from 'linaria';

export const VerifyCodeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 310px;

  @media (max-width: 440px) {
    height: calc(100vh - 80px);
  }
`;

export const VerifyCodeWrapper = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const VerifyCodeLabel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const rowMargin = css`
  margin-top: 32px;
`;

export const inputErrorMargin = css`
  margin-top: 4px;
`;
